<template>
  <div
    v-if="data.separator"
    class="flex-[99999]"
  />
  <q-item
    v-else
    class="Nv0-li"
    clickable
    :active="active"
    tag="li"
    @click="$emit('Nv0Click')"
  >
    <slot>
      <!-- Nv0 Slot onde entra  o conteudo da li  -->
    </slot>

    <!-- Submenus  ------------------------------>
    <q-list
      v-if="haveSubmenu"
      tag="ul"
      class="submenu"
      :level="haveSubmenu[0].nivel"
    >
      <li class="Nv1-li">
        <!-- Nv1 Header  -->
        <header
          v-if="showHeader"
          class="Nv1-header"
        >
          <OButton
            v-if="Screen.lt.md"
            primary
            class="w-32 h-32 p-0 !bg-primary-light !text-neutral-100"
            @click="onBackCLick"
          >
            <q-icon
              class="w-20 h-20 !text-neutral-100"
              name="svguse:/icons.svg#icon_back"
            />
          </OButton>
          <p class="text-title-4 one-line">
            {{ props.data.title }}
          </p>
          <q-icon
            size="24px"
            :name="props.data.icon"
          />

          <OButton
            v-if="Screen.lt.md"
            primary
            class="w-32 h-32 p-0 !bg-primary-light"
            :class="{ 'opacity-0 invisible': !Screen.lt.md }"
            @click="$emit('click:close')"
          >
            <q-icon
              class="w-32 h-32 !text-neutral-100"
              name="svguse:/icons.svg#icon_close"
            />
          </OButton>
        </header>
      </li>
      <!-- Nv1 item  -->
      <q-item
        v-for="Nv1 in haveSubmenu"
        :key="Nv1.title"
        clickable
        tag="li"
        class="submenu-li"
        :exact="false"
        @click.stop="(e) => onSubmenuItemClick(Nv1, e, 'aqui')"
      >
        <!-- Nv1 Content  -->
        <q-item-section>
          <p class="one-line font-medium text-primary-pure">
            {{ Nv1.title }}
          </p>
        </q-item-section>

        <!-- Button ADD && List -->
        <q-item-section
          v-if="Nv1.add || Nv1.list"
          avatar
          class="flex gap-4 flex-nowrap flex-row items-center"
        >
          <o-button
            v-if="Nv1.list"
            class="action-button"
            :to="Nv1.list"
            size="sm"
            tertiary
          >
            <q-tooltip v-bind="tooltipProps">
              Lista
            </q-tooltip>

            <q-icon
              size="1.25rem"
              name="svguse:/icons.svg#icon_list"
            />
          </o-button>

          <o-button
            v-if="Nv1.add"
            class="action-button"
            :to="Nv1.add"
            size="sm"
            tertiary
          >
            <q-tooltip v-bind="tooltipProps">
              Adicionar
            </q-tooltip>

            <q-icon
              size="1.25rem"
              name="svguse:/icons.svg#icon_add"
            />
          </o-button>
        </q-item-section>

        <!-- Arrow  -->
        <q-item-section
          v-if="Nv1.submenu"
          avatar
          class="text-primary-pure"
        >
          <q-icon
            class="text-primary-pure"
            size="1.5rem"
            name="navigate_next"
          />
        </q-item-section>

        <!-- Submenu Nv2 -->
        <q-list
          v-if="Nv1.submenu"
          tag="ul"
          class="submenu"
          :level="Nv1.submenu[0].nivel"
        >
          <li class="Nv2-li" />

          <q-item
            v-for="Nv2 in Nv1.submenu"
            :key="Nv2.title"
            clickable
            tag="li"
            class="submenu-li"
            @click.stop="(e) => onSubmenuItemClick(Nv2, e, 'acola')"
          >
            <q-item-section>
              <p class="one-line font-medium text-primary-pure">
                {{ Nv2.title }}
              </p>
            </q-item-section>

            <!-- Arrow  -->
            <q-item-section
              v-if="Nv2.submenu"
              avatar
              class="text-primary-pure"
            >
              <q-icon
                class="text-primary-pure"
                size="1.5rem"
                name="navigate_next"
              />
            </q-item-section>

            <q-list
              v-if="Nv2.submenu"
              tag="ul"
              class="submenu"
              :level="Nv2.submenu[0]?.nivel"
            >
              <li class="Nv3-li" />

              <q-item
                v-for="Nv3 in Nv2.submenu"
                :key="Nv3.title"
                clickable
                tag="li"
                class="submenu-li"
                @click.stop="(e) => onSubmenuItemClick(Nv3, e, 'acola')"
              >
                <q-item-section>
                  <p class="one-line font-medium text-primary-pure">
                    {{ Nv3.title }}
                  </p>
                </q-item-section>
              </q-item>
            </q-list>
          </q-item>
        </q-list>
      </q-item>
    </q-list>
  </q-item>
</template>

<script>
// export default { inheritAttrs: false }
</script>

<script setup>
import { inject, ref } from 'vue'
import { onBeforeRouteUpdate, useRouter } from 'vue-router'
import { Screen } from 'quasar'
import OButton from 'components/Button/OButton.vue'

const props = defineProps({
  data: Object,
  sidebar: null,
  showHeader: {
    type: Boolean,
    default: false,
  },
})

const active = ref(window.location.pathname.includes(props.data?.name))

const haveSubmenu = ref(props.data.submenu)

const tooltipProps = {
  anchor: 'top middle',
  self: 'bottom middle',
  offset: [10, 10],
}

const emit = defineEmits(['click:close', 'Nv0Click'])

const router = useRouter()

const pathTo = inject('pathTo')
const state = inject('state')

function onSubmenuItemClick(item, event, onde) {
  event.stopImmediatePropagation()
  event.stopPropagation()
  // event.stopImmediatePropagation()
  const link =  item.href
  if (link) {
    state.value = {
      hover: false,
      open: false,
      passive: true,
    }

    setTimeout(() => {
      document
        .querySelectorAll('.Nv0-ul > li')
        .forEach((i) => i.classList.remove('active'))
      window.location.href = link
      state.value.passive = false
    }, 100)
  }
}

function onBackCLick() {
  setTimeout(() => {
    document
      .querySelectorAll('.Nv0-ul > li')
      .forEach((i) => i.classList.remove('active'))
  }, 100)
}
onBeforeRouteUpdate((v) => {
  active.value = v.name.includes(props.data?.name)
})
</script>

<style lang="sass">
@import 'css/quasar/variables'
@import 'css/quasar/core/typography'
@import 'css/responsivo'

.OSidebar li
  position: relative
  user-select: none
  @include text(paragraph-2)
  color: rgb(var(--primary-pure))
  // cursor: initial !important
  // [href]
  //   cursor: pointer

  .body--dark &
    color: rgba(var(--white),0.9) !important

  .submenu
    display: none
    flex-direction: column
    height: 100vh
    top: var(--sidebar-top)
    position: fixed
    width: var(--Nv1-sidebar-width)
    border-left: var(--Nv0-sidebar-border)
    border-right: var(--Nv0-sidebar-border)
    transform: translate3d(0,0,0)


    &[level="1"]
      left: calc(var(--Nv1-sidebar-width) - 1px)
      z-index: var(--Nv1-sidebar-z-index)
      background: var(--Nv1-sidebar-bg)
      @include d(md)
        left: 0
        width: 100%

    &[level="2"]
      left: calc((var(--Nv2-sidebar-width)) - 1px)
      z-index: var(--Nv2-sidebar-z-index)
      width: var(--Nv2-sidebar-width)
      background: var(--Nv2-sidebar-bg)
      top: 0
      @include d(md)
        left: 0
        width: 100%
    &[level="3"]
      left: calc((var(--Nv3-sidebar-width)) - 1px)
      width: var(--Nv3-sidebar-width)
      z-index: var(--Nv3-sidebar-z-index)
      background: var(--Nv3-sidebar-bg)
      top: 0
      @include d(md)
        left: 0
        width: 100%



  .Nv1-li,
  .Nv2-li,
  .Nv3-li
    margin-bottom: 2rem
    margin-top: 4rem

  .Nv1-header
    display: flex
    align-items: center
    gap:.5rem
    border-bottom: var(--Nv0-sidebar-border)
    padding: 1rem
    height: var(--sidebar-header-height)
    justify-content: space-between
    position: relative

    //ornamento verde Nv1
    &::after
      content:''
      display: block
      position: absolute
      top: 0
      bottom: 0
      margin: auto 0
      left: 0
      background: rgb(var(--primary-pure))
      height: 1.5rem
      width:3px
      border-radius: 0 8px 8px 0
    .q-icon
      color: rgb(var(--primary-pure))

  .Nv2-header
    display: flex
    align-items: center
    gap:.5rem
    border-bottom: var(--Nv0-sidebar-border)
    padding: 1rem
    height: var(--sidebar-header-height)
    justify-content: space-between
    position: relative

  //Button Add and List
  .action-button
    width: 2rem !important
    height: 2rem !important
    padding: 0 !important
    // background: rgba(var(--neutral-100), 0.1)

//Dark
.body--dark .action-button
      background: rgba(var(--white), 0.05) !important


//ativa os submenu no hover e active
.sidebar-open .OSidebar
  li:not(.Nv0-li):hover,
  li.active
    >.q-focus-helper
      opacity: 0.15 !important
      background: currentColor
    > .submenu
      display: flex
      animation: show .25s var(--Nv0-sidebar-transition) both 0.05s
      &[level="2"]
        animation: show .25s var(--Nv0-sidebar-transition) both 0.05s


@keyframes show
  0%
    opacity: 0
    transform: translateX(-10px)
    pointer-events: none
  100%
    opacity: 1
    transform: translateX(0px)
    pointer-events: all
</style>
